export default {
    pixi: 'app = new PIXI.Application({width:600,height:600,antialias: true});\n' +
        'graphics = new PIXI.Graphics();\n' +
        'app.stage.addChild(graphics);\n' +
        'CENTER_X = app.view.width/2;\n' +
        'CENTER_Y = app.view.height/2;\n' +
        '// ------------------ REMOVE LINES ABOVE TO SEE PERFORMANCE DIFFERENCE!  ------------------\n' +
        'graphics.clear();\n' +
        'graphics.lineStyle(50,0x00FF00,1);\n' +
        'graphics.arc( CENTER_X, CENTER_Y, 100,0,(Math.PI/180)*(360));\n' +
        'graphics.endFill();',
    canvas: 'canvas = document.createElement(\'canvas\');\n' +
        '// ------------------ REMOVE LINES ABOVE TO SEE PERFORMANCE DIFFERENCE!  ------------------\n' +
        'const ctx = canvas.getContext(\'2d\');\n' +
        'canvas.width = 600;\n' +
        'canvas.height = 600;\n' +
        'ctx.fillStyle = "black";\n' +
        'ctx.fillRect(0, 0, canvas.width, canvas.height);\n' +
        'const CENTER_X = canvas.width/2;\n' +
        'const CENTER_Y = canvas.height/2;\n' +
        'ctx.strokeStyle = \'#00FF00\';\n' +
        'ctx.lineWidth = 50;\n' +
        'ctx.beginPath();\n' +
        'ctx.arc( CENTER_X, CENTER_Y, 100,0,(Math.PI/180)*(360));\n' +
        'ctx.stroke();'
}